import mergeClasses from 'shared/lib/utils';
export default function BlurLoading({
  loading,
  className,
  title
}: {
  loading: boolean;
  className?: string;
  title?: string;
}) {
  if (!loading) return null;
  return <div className={mergeClasses('absolute inset-0 flex items-center justify-center bg-opacity-50 backdrop-blur-sm z-15 flex-col gap-5', className)} data-sentry-component="BlurLoading" data-sentry-source-file="blur-loading.tsx">
      {title && <p>{title}</p>}
      <div className="size-10 animate-spin rounded-full border-4 border-solid border-primary  border-e-transparent" />
    </div>;
}